import { api as adminBffSdk, createTagsTag, SUGGESTED_TAGS_LIST } from './index';

export function resetTagSuggestions() {
    return adminBffSdk.util.invalidateTags([createTagsTag(SUGGESTED_TAGS_LIST)]);
}
